import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/router';
import MiaxLogo from './MiaxLogo';
import style from './style.module.scss';
import LevelArrowIcon from '@ping/assets/Icon/levelArrow.svg';

import TrendingIcon from '@ping/assets/Icon/trending.svg';
import BarChartIcon from '@ping/assets/Icon/bar-chart.svg';
import SwapIcon from '@ping/assets/Icon/swap.svg';
import NoteBookIcon from '@ping/assets/Icon/noteBook.svg';
import PortfolioIcon from '@ping/assets/Icon/portfolio.svg';

import { useDesktopDevice, useIsUserLoggedIn } from '@ping/hooks';

import { ProfileDropdownMenu, GetStartedButton } from '@ping/components/Header';
import clsx from 'clsx';
import { APP_VERSION } from '@ping/configs';
import { useMobile } from '@ping/hooks';

interface NavLink {
  title: string;
  href: string;
  icon: JSX.Element;
  protected?: boolean;
}

const navLinks: NavLink[] = [
  { title: 'Dashboard', href: '/miax', icon: <TrendingIcon className={style['nav-icon']} /> },
  { title: 'Markets', href: '/markets', icon: <BarChartIcon className={style['nav-icon']} /> },
  { title: 'Simple Trading', href: '/miax/simple-trading', icon: <SwapIcon className={style['nav-icon']} /> },
  { title: 'Advanced Trading', href: '/trade', icon: <NoteBookIcon className={style['nav-icon']} /> },
  {
    title: 'Portfolio',
    href: '/miax/portfolio',
    icon: <PortfolioIcon className={style['nav-icon']} />,
    protected: true,
  },
  {
    href: '/user/portfolio/ramp',
    title: 'Buy & Sell',
    icon: <LevelArrowIcon />,
    protected: true,
  },
];

const MiaxNavbar: React.FC = () => {
  const isUserLoggedIn = useIsUserLoggedIn();
  const router = useRouter();
  const { pathname } = router;
  const isDesktop = useDesktopDevice();
  const isMobile = useMobile();

  const visibleLinks = navLinks.filter(link => !(link.protected && !isUserLoggedIn));

  return (
    <nav className={clsx(style['miax-navbar'], style['nav-user'])} data-testid='miax-navbar'>
      <div className={style['navbar-content']}>
        <div className={style['brand']}>
          <a href='/'>
            <div className={style['brand-area']}>
              <div className={style['logo-badge-wrapper']}>
                <MiaxLogo height={isMobile ? 44 : 32} />
                <img
                  className={style['app-stage-badge']}
                  src={`/img/${APP_VERSION.toLowerCase()}-badge.svg`}
                  alt={`${APP_VERSION.toLowerCase()} badge`}
                />
              </div>
              <div className={style['brand-text-v']}>
                <span>Digital</span>
                <span>Commodities Exchange</span>
              </div>
            </div>
          </a>
        </div>
        {isDesktop && (
          <div className={style['links']}>
            {visibleLinks.map(link => (
              <Link key={link.href} href={link.href as any} legacyBehavior passHref>
                <a className={pathname.startsWith(link.href) ? style['active'] : undefined}>
                  {link.icon}
                  <span>{link.title}</span>
                </a>
              </Link>
            ))}
          </div>
        )}
        <div className={style['actions']}>
          {isUserLoggedIn ? <ProfileDropdownMenu /> : <GetStartedButton data-testid='login-button-nav' />}
        </div>
      </div>
    </nav>
  );
};

export default MiaxNavbar;
